import { createHead, VueHeadMixin } from "@unhead/vue/client";

const APP_NAME = "Katana";

export function pageTitle(...parts) {
  const title = parts.filter(Boolean).join(" · ");
  return title || undefined;
}

export function installHead(app) {
  const head = createHead();
  head.push({ titleTemplate: (title) => (title ? `${title} — ${APP_NAME}` : APP_NAME) });
  app.use(head);
  app.mixin(VueHeadMixin);
}
